
(function waitForjQuery() {
  if (window.jQuery) {
      jQuery( document ).ready( function($) {

        jQuery('.custom-next-slide').on('click', function(){
          let currentMedia = jQuery('.product-gallery--media[data-gallery-selected=true]').data('media');
          jQuery('.gallery-navigation--scroller [data-media="'+ currentMedia +'"]').next('.product-gallery--image-thumbnail').trigger('click');
        })
    
        jQuery('.custom-previous-slide').on('click', function(){
          let currentMedia = jQuery('.product-gallery--media[data-gallery-selected=true]').data('media');
          jQuery('.gallery-navigation--scroller [data-media="'+ currentMedia +'"]').prev('.product-gallery--image-thumbnail').trigger('click');
        })
    
        
        jQuery('.subcollection-ul-menu.sub-menu').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 7,
          slidesToScroll: 7,
          responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 6
              }
            },
            {
              breakpoint: 1400,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
                slidesToScroll:4
              }
            },
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
                slidesToScroll:3
              }
            },
            {
              breakpoint: 859,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 670,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
          ]
      });
    
        jQuery('.product-custom-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: $('.product-custom-slider-data').data('slide-counter'),
            slidesToScroll: 4,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 540,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });
    
      if ($('[rel=gallery]').length) {
        $('[rel=gallery]').fancybox({
          baseClass: 'gallery-section__lightbox',
          clickContent: 'nextOrClose',
          afterShow() {
            // Loop through fancybox images, add alt attributes
            const fancyImages = $('.fancybox-image');
            $('.gallery__image').each((index, image) => {
              const $image = $(image);
              const alt = $image.attr('alt');
              fancyImages.eq(index).attr('alt', alt);
            });
          },
        });
      }
    
      $('.lightbox[rel="gallery"]').fancybox();
      
      
      const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');
    
      // For each iframe, if parent is a responsive video wrapper do nothing
      // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper
    
      function getAspectRatio(width, height) {
        const ratio = width / height;
    
        // Determine ratio to be used
        if (Math.abs(ratio - 1 / 1) === 0) {
          return '1:1';
        }
        return (Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9)) ? '4:3' : '16:9';
      }
    
      $videoIframes.each((_index, iframe) => {
        // Update selector
        const $iframe = $(iframe);
    
        // Grab src
        const source = $iframe.attr('src');
    
        if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
          $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
        }
      });
    
      // Initiate lazyframe
      window.lazyframe('.lazyframe');
    
    
      var lastScrollTop = 0; // Store last scroll position
    
      $(window).on("scroll", function () {
          var st = $(this).scrollTop(); // Get current scroll position
    
          if( st === 0 || st < 150 ){
            $('body').removeClass('scrolling-down scrolling-up');
            $('body').removeClass('scrolling');
          } else {
            $('body').addClass('scrolling');
            if (st > lastScrollTop) {
              $('body').addClass('scrolling-down');
              $('body').removeClass('scrolling-up');
            } else if (st < lastScrollTop) {
              $('body').removeClass('scrolling-down');
              $('body').addClass('scrolling-up');
            }
          }
    
          lastScrollTop = st; // Update last scroll position
      });
    
      setTimeout( function(){
        if( $('.mw-apo-add-to-cart-custom').length ){
          $('.shopify-payment-button__button').insertAfter('.mw-apo-add-to-cart-custom');
          $('.product-main').addClass('has-custom');
        } else {
          $('.product-form--atc').addClass('has-no-custom');
          $('.product-main').addClass('has-no-custom');
          console.log('has no custom')
        }
      }, 2000 );
    
    
      $('.template-product .easytabs-contents table').each(function () {
        if (!$(this).parent().hasClass("table-wrapper")) {
          $(this).wrap("<div class='table-wrapper'></div>");
        }
      });
    
      });
  } else {
      setTimeout(waitForjQuery, 50);
  }
})();